import {
    ADD_FUNDS_TO_USD_BALANCE_ROUTE,
    ADMIN_ROUTE,
    CONTACT_ROUTE,
    EMAIL_UNSUBSCRIBE_ROUTE,
    LANG_PREFIX_ROUTE,
    LIBRARY_ROUTE,
    LOGIN_ROUTE,
    MAIN_ROUTE,
    NEWS_DETAIL_ROUTE,
    NEWS_ROUTE,
    PAY_ROUTE,
    POLL_LIBRARY_ROUTE,
    PRICING_ROUTE,
    PROMO_PAY_ROUTE,
    REGISTRATION_ROUTE,
    RESET_PASSWORD_ROUTE,
    RETURN_ROUTE,
    RETURN_ROUTE_ADD_FUNDS,
    STORE_ROUTE,
    USER_ACC_ROUTE,
    USER_DASHBOARD_ROUTE,
    VERIFY_EMAIL_ROUTE,
} from "./utils/consts";
import AdminDashboard from "./pages/internal/AdminDashboard";
import UserAccount from "./pages/internal/UserAccount";
import Auth from "./pages/public/Auth/Auth";
import Pay from "./pages/internal/Pay";
import Return from "./components/payment/Return";
import UserDashboard from "./pages/internal/UserDashboard";
import AssignLibrary from "./pages/internal/AssignLibrary";
import Pricing_Public_Page from "./pages/internal/Pricing_Public/Pricing_Public_Page";
import PollLibrary from "./pages/internal/PollLibrary";
import AddFundsToUsdBalance from "./pages/internal/AddFundsToUsdBalance";
import AddFundsReturn from "./components/payment/AddFundsReturn";
import NewsListPage from "./pages/NewsListPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import PromotionPay from "./pages/internal/PromotionPay";
import VerifyEmail from "./pages/internal/VerifyEmail";
import ProductStore from "./pages/internal/ProductStore";
import DevHomeFallback from "./pages/public/DevHomeFallback";
import Contact_Page from "./pages/public/Contact/Contact_Page";
import EmailUnsubscribe from "./pages/public/EmailUnsubscribe";

const withLangPrefix = (p) => `${LANG_PREFIX_ROUTE}${p === "/" ? "" : p}`;

export const authAdminRoutes = [
    { path: ADMIN_ROUTE, Component: AdminDashboard },
];

const baseAuthRoutes = [
    { path: USER_DASHBOARD_ROUTE, Component: UserDashboard },
    { path: LIBRARY_ROUTE, Component: AssignLibrary },
    { path: STORE_ROUTE, Component: ProductStore },
    { path: NEWS_ROUTE, Component: NewsListPage },
    { path: NEWS_DETAIL_ROUTE, Component: NewsDetailPage },
    { path: USER_ACC_ROUTE, Component: UserAccount },
    { path: RETURN_ROUTE, Component: Return },
    { path: RETURN_ROUTE_ADD_FUNDS, Component: AddFundsReturn },
    { path: POLL_LIBRARY_ROUTE, Component: PollLibrary },
    { path: ADD_FUNDS_TO_USD_BALANCE_ROUTE, Component: AddFundsToUsdBalance },
];

const basePublicRoutes = [
    { path: RESET_PASSWORD_ROUTE, Component: Auth },
    { path: VERIFY_EMAIL_ROUTE, Component: VerifyEmail },
    { path: PAY_ROUTE, Component: Pay },
    { path: PROMO_PAY_ROUTE, Component: PromotionPay },
    { path: PRICING_ROUTE, Component: Pricing_Public_Page },
    { path: CONTACT_ROUTE, Component: Contact_Page },
    { path: EMAIL_UNSUBSCRIBE_ROUTE, Component: EmailUnsubscribe },
    { path: LOGIN_ROUTE, Component: Auth },
    { path: REGISTRATION_ROUTE, Component: Auth },
    { path: MAIN_ROUTE, Component: DevHomeFallback },
];

export const authRoutes = [
    ...baseAuthRoutes,
    ...baseAuthRoutes.map((r) => ({ ...r, path: withLangPrefix(r.path) })),
];

export const publicRoutes = [
    ...basePublicRoutes,
    ...basePublicRoutes.map((r) => ({ ...r, path: withLangPrefix(r.path) })),
];
